// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.K9Kt_jGJAWxpni {
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  height: 90vh;
  max-height: 680px;
  padding: var(--ds-space-300, 24px) var(--ds-space-300, 24px) var(--ds-space-0, 0);
  row-gap: var(--ds-space-200, 16px);
}
.K9Kt_jGJAWxpni .HkArtTePuUslsf {
  flex: 1;
  margin: var(--ds-space-0, 0) var(--ds-space-negative-300, -24px);
  padding: var(--ds-space-0, 0) var(--ds-space-300, 24px) var(--ds-space-300, 24px);
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: none;
}
.K9Kt_jGJAWxpni.BpcWO9dt7MfAnD {
  height: 100%;
  max-height: unset;
  padding: unset;
}
.K9Kt_jGJAWxpni.BpcWO9dt7MfAnD .HkArtTePuUslsf {
  margin: unset;
  padding: var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-075, 5px) var(--ds-space-0, 0);
  scrollbar-width: unset;
}
.K9Kt_jGJAWxpni.YQpMPsNuwUw7Lt {
  justify-self: center;
  max-width: 640px;
  padding-bottom: var(--ds-space-1000, 80px);
}
@media screen and (max-width: 640px) {
  .K9Kt_jGJAWxpni.YQpMPsNuwUw7Lt {
    max-width: 100%;
  }
}
`, ""]);
// Exports
export var boardSwitcher = `K9Kt_jGJAWxpni`;
export var scrollContainer = `HkArtTePuUslsf`;
export var panel = `BpcWO9dt7MfAnD`;
export var singlePanel = `YQpMPsNuwUw7Lt`;
export default ___CSS_LOADER_EXPORT___;
